import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dialog", "form", "errors", "notice", "submit"]

  open() {
    this.noticeTarget.classList.add("d-none")
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClose(event) {
    if (event.target !== this.dialogTarget) return
    const bounds = this.dialogTarget.getBoundingClientRect()
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close()
  }

  disconnect() {
    this.close()
  }

  async create(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.saving) return

    const body = new FormData(this.formTarget)
    this.saving = true
    this.submitTarget.disabled = true
    this.submitTarget.textContent = "Creating…"
    this.errorsTarget.classList.add("d-none")

    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST", body, credentials: "same-origin", redirect: "error",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        }
      })
      if (!response.headers.get("content-type")?.includes("application/json")) {
        throw new Error("Unable to create the account. Check that you are signed in and try again.")
      }
      const result = await response.json()
      if (!response.ok) throw new Error(result.errors?.join(" ") || result.error || "Unable to create the account. Please try again.")
      if (!this.element.isConnected) return

      this.formTarget.reset()
      this.close()
      this.noticeTarget.textContent = result.message
      this.noticeTarget.classList.remove("d-none", "alert-success", "alert-warning")
      this.noticeTarget.classList.add(result.warning ? "alert-warning" : "alert-success")
      this.element.dispatchEvent(new CustomEvent("account-form:created", { bubbles: true }))
    } catch (error) {
      if (!this.element.isConnected) return
      this.errorsTarget.textContent = error.message || "Unable to create the account. Please try again."
      this.errorsTarget.classList.remove("d-none")
      if (!this.dialogTarget.open) this.dialogTarget.showModal()
      this.errorsTarget.focus()
    } finally {
      this.saving = false
      this.submitTarget.disabled = false
      this.submitTarget.textContent = "Create account"
    }
  }
}
